import React from 'react'
import clsx from 'clsx';
import { connect } from 'react-redux'
import HeaderComponent from '../../components/Header-component/HeaderComponent'
import FooterComponent from '../../components/Footer-component/FooterComponent'
import SidebarComponent from '../../components/Sidebar-component/Sidebar-component'
import * as globalPopuphandler from '../../store/Actions/popup-actionCreator'
import './layout.css'

import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import Drawer from '@material-ui/core/Drawer';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch } from "react-redux";
import { UserPermssions } from "../../store/Actions"
import { status } from '../../store/Constants';
import Loader from "../../components/Loader"
import CryptoJS from 'crypto-js';
import jwt_decode from "jwt-decode";
import * as authActionCreators from '../../store/Actions/Authentication-creator'
import myadminPermissions from './adminPermssion.json';
import { useHistory } from 'react-router-dom'
import efoneLogo from '../../utils/images/logo-new-2.png'

const drawerWidth = 290;

const useStyles = makeStyles((theme) => ({
    menuButton: {
        marginRight: 0,
    },
    menuButtonHidden: {
        display: 'none',
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(6),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(7),
        },
    },
}));

function Layout(props: any) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const history: any = useHistory();
    const [loading, setLoading] = React.useState<any>(false);
    const [open, setOpen] = React.useState(true);
    const [user, setUser] = React.useState<any>({})
    const [data, setData] = React.useState<any>({})
    const [userPermission, setUserPermission] = React.useState<any>({});
    const handleDrawerOpen = () => {
        setOpen(false);
    };
    const handleDrawerClose = () => {
        setOpen(true);
    };


    React.useEffect(() => {
        var data = localStorage.getItem("user")
        var newData = data ? JSON.parse(data) : ""
        setUser(newData)
    }, [])

    const token = Object.keys(user).length && user.access ? user.access.token : null;
    React.useEffect(() => {
        if (token) {
            const decodedHeader: any = jwt_decode(token);
            if (decodedHeader?.key) {
                const decryptData2 = (encryptedData: any) => {
                    var C = CryptoJS;
                    var Key = C.enc.Utf8.parse("oSOhgvKFi2AbgyVwtKMKwFV8pSc5kyxU");
                    var IV = C.enc.Utf8.parse("oSOhgvKFi2AbgyVw");
                    var decryptedText = C.AES.decrypt(encryptedData, Key, {
                        iv: IV,
                        mode: C.mode.CBC,
                        padding: C.pad.Pkcs7
                    });
                    return decryptedText.toString(CryptoJS.enc.Utf8);
                }
                var userData = JSON.parse(decryptData2(decodedHeader?.key)) ? JSON.parse(decryptData2(decodedHeader?.key)) : ""
                setData(userData)
                if (userData.role === 2) {
                    if (props.user_permissions_status === status.SUCCESS) {
                        setLoading(false)
                        if (Object.keys(props.userPermissionsList.data).length) {
                            setUserPermission(props.userPermissionsList.data);
                        }
                    }
                }
                if (parseInt(userData.role) === 1) {
                    setLoading(false)
                    setUserPermission(myadminPermissions);
                }
            }
        }
    }, [token])

    React.useEffect(() => {
        dispatch(UserPermssions.UserPermssion(data.role));
    }, [data.role])


    React.useEffect(() => {
        setLoading(data.role === 2 ? true : false)
        if (data.role === 2) {
            if (props.user_permissions_status === status.SUCCESS) {
                setLoading(false)
                if (Object.keys(props.userPermissionsList.data).length) {
                    setUserPermission(props.userPermissionsList.data);
                }
            }
        }
        // if (parseInt(data.role) === 1) {
        //         setLoading(false)
        //         setUserPermission(myadminPermissions);
        // }
    }, [props.user_permissions_status,props.userPermissionsList?.data]);






    if (loading) return <Loader />
    return (
        <div className="layout_section">
            <Drawer
                variant="permanent"
                className={`${open ? 'drawerPaperClose' : 'drawerPaper'}`}
                open={open}
            >
                <div className="sidebar_container">
                    <div className="sideber_wrapper">
                        <div className="sidebar_component">
                            <div className="sidebar_content">
                                <div className="sidebar_header">
                                    <div className="sidebar_logo">
                                        <img src={efoneLogo} alt="sidebar logo" height="50px" />
                                    </div>
                                    <div className="menuButton">
                                        <IconButton
                                            edge="start"
                                            color="inherit"
                                            aria-label="open drawer"
                                            onClick={handleDrawerOpen}
                                            className={clsx(classes.menuButton, !open && classes.menuButtonHidden)}
                                        >
                                            <MenuIcon />
                                        </IconButton>
                                        <IconButton
                                            onClick={handleDrawerClose}
                                            className={clsx(classes.menuButton, open && classes.menuButtonHidden)}
                                        >
                                            <ChevronLeftIcon />
                                        </IconButton>
                                    </div>
                                </div>
                                <SidebarComponent userPermission={userPermission} />
                            </div>
                        </div>
                    </div>
                </div>
            </Drawer>
            <div className="main_body_section">
                <div className="header_section">
                    <HeaderComponent />
                </div>
                <div className="childComponenet">
                    {props.children}
                </div>
                <div className="footer_container">
                    {/* footer container */}
                    <FooterComponent />
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state: any) => {
    const { user_permissions_status, userPermissionsList } = state.usersPermissionsReducer;
    return {
        states: state,
        authData: state.authState,
        userPermissionsList,
        user_permissions_status
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        clearPoPUP: () => dispatch(globalPopuphandler.clearGlobalPopup()),
        loguserout: () => dispatch(authActionCreators.initAuthLogout())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Layout)
